import { render, staticRenderFns } from "./Recupera.vue?vue&type=template&id=36134361"
import script from "./Recupera.vue?vue&type=script&lang=js"
export * from "./Recupera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports